import widgets from '../widgets'

const {
  CURRENT_VALUE,
  ALARM_STATE,
  STATUS
} = widgets

export default [
  STATUS({}),
  CURRENT_VALUE({}),
  ALARM_STATE({}),
]
